import PropTypes from "prop-types"
import React from "react"
import { Link, useStaticQuery } from "gatsby"

import "../css/protect-info.css"

import { HandleImages } from "../components/functions"
import Img from "gatsby-image"
import bored from "../images/bored.webm"
import door from "../images/door.webm"
import OnVisible from "react-on-visible"

import pAIcon from "../images/project-ares-logo.svg"
import spikesTop from "../images/spikes-top.svg"

import spikesBottom from "../images/spikes-bottom.svg"

const style = {}
var height
var position

class LearnInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: true,
      active: true,
    }
  }

  componentDidMount() {
    var current = this
    console.log("mount", this.state.active)
    this.setState({
      safari:!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)
  })
    /* setInterval(function() {
        current.setState({
          active: !current.state.active
        });
      }, 5000)*/
  }

  render() {
    return (
      <OnVisible className="protect-info-wrapper">
        <div className="top">
          <img src={spikesTop} className="bgtop" />

          <img src={spikesBottom} className="bgbottom" />
          <div className="left">
            {" "}
            <div>
              <div>
                <p>
                  Organizations looking to protect their company from
                  cyber-attacks have two primary pains:{" "}
                </p>
                <ul>
                  <li>Lack of budget</li>
                  <li>Lack of personnel</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="bottom">
          <div className="video-wrapper" onChange={this.handleVis}>
            {this.state.visible && (
         

this.state.safari?<HandleImages name="bored"/>:        <video autoplay="true" loop="true" muted="true">
<source src={bored} type="video/webm" />
</video>



            )}
          </div>
          <div className="left">
            <div>
              <p>Companies are hard-pressed to find talent and skills that match their readiness needs. </p>
            
              <div className="stat-row">
                <div className="stat">
                  36%
                  <svg viewBox="0 0 110 110" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="55" cy="55" r="50" />
                  </svg>
                </div>
                <p>
                  of organizations say their #1 concern is their lack of skilled
                  security personnel.
                </p>
              
              </div>
              <h4>But</h4>
              <div className="stat-row">
                <div className="stat">
                  3%
                  <svg viewBox="0 0 110 110" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="55" cy="55" r="50" />
                  </svg>
                </div>
                <p>
                  of today's graduates entering the talent pool possess a skill
                  set in cyber security
                </p>
              </div>
            </div>
          </div>

          <div className="right">
            <div>
              <span>
                {" "}
                Cyber security training is usually a low budget line item
                swimming in a sea of bigger business priorities.{" "}
              </span>
              <h3>
                Yet tighter budgets does not have to mean cutting corners on cyber
                training.
              </h3>
            </div>
            <div>
              {" "}
              <h3>
               
                <span>Hardening organizational posture starts with people:</span><br/>
                The frontline defenders who are battling incoming threats to
                the network.
              </h3>
              <p>
              To ensure those professionals are equipped with the skills and competencies to fight proactively, they must train and hone their skills persistently.
              </p>
            </div>
          </div>
        </div>

        <div className="last">
          <div className="logo-wrapper">
            <img alt="Project Ares Logo" src={pAIcon} />{" "}
          </div>{" "}
          <p>
          provides the immersive, hands-on scenario cyber training necessary to help protect organizational networks and reputation. 
          </p>
          <HandleImages name="laptopIllustration" />
        </div>
      </OnVisible>
    )
  }
}

export default LearnInfo
